module.exports = __webpack_public_path__ + "img/NoGovStarted.0b4e38f4.svg";